<div class="auth__login__panel" nativeDesktopClass="desktop">
  <div fxLayout="row" fxLayoutAlign="space-around start" class="auth__login__panel__header">
    <div fxFlex="50" class="auth__login__panel__header-logo">
      <bfx-logo-svg></bfx-logo-svg>
    </div>
    <div fxFlex="50" class="auth__login__panel__header-title">{{ frameTag }}</div>
  </div>
  <div class="auth__login__panel__body">
    <div class="noAuthContent">
      <div fxFlex fxLayout="row" fxLayoutAlign="space-around center">
        <div fxFlex="27" class="noAuthIconSpacing">
          <span class="icon icon-close bfx-icon-xlg"></span>
        </div>
        <div class="noAuthTextSpacing" fxFlex="73" fxLayout="column" fxLayoutAlign="start start">
          <div fxFlex class="title">ACCESS DENIED!</div>
          <div fxFlex="50" class="text">
            You are not authorized to vew the requested resource.<br />
            You need to
            <b><a role="button" routerLink="/restart-logout">Sign-in</a></b> in order to access the
            OMS.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="auth__login__panel__footer">
    <p class="copyright">&copy; BarracudaFX</p>
  </div>
</div>
